var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"md":"12"}},[(_vm.isCompaniesValidList)?_c('ul',[_c('li',{staticClass:"font-weight-bold text--primary text-decoration-underline"},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{
            name: 'companyDetail',
            params: {
              companyId: _vm.company.id,
            },
          }},domProps:{"textContent":_vm._s(_vm.company.name)}})],1)]):_c('ul',[_c('li',{staticClass:"font-weight-bold text--primary",domProps:{"textContent":_vm._s(_vm.$tc('na'))}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }